export default
    {
        path:'/account',
        component: require('./index').default,
        parent:'root',
        name:'account',
        children:[
            {
                path:'setting',
                component: require('./accountSet/index').default,
                meta: {
                    isLogin: true
                }
            },
            {
                path:'modifypsw',
                component: require('./accountSet/modifyPsw').default,
                meta: {
                    isLogin: true
                }
            },
            {
                path:'findpsw',
                component: require('./accountSet/findPsw').default,
                meta: {
                    isLogin: true
                }
            },
            {
                path:'replacephone',
                component: require('./accountSet/replacePhone').default,
                meta: {
                    isLogin: true
                }
            },
            {
                path:'apply',
                component: require('./apply/index').default,
                meta: {
                    isLogin: true
                }
            },
            {
                path:'auction',
                component: require('./auction/index').default,
                meta: {
                    isLogin: true
                }
            },
            {
                path:'msg',
                component: require('./msg/index').default,
                meta: {
                    isLogin: true
                }
            },
        ]
    }
